import { render, staticRenderFns } from "./MyWorks.vue?vue&type=template&id=3dae17fe&scoped=true&"
import script from "./MyWorks.vue?vue&type=script&lang=js&"
export * from "./MyWorks.vue?vue&type=script&lang=js&"
import style0 from "./MyWorks.vue?vue&type=style&index=0&id=3dae17fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dae17fe",
  null
  
)

export default component.exports